import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

import { getCatalogueItems } from "../../../../redux/actions/catalogue.action";
import { getHardwarePosTerminals } from "../../../../redux/actions/pos.action";

export const useFetchSalesItems = () => {
    const dispatch = useDispatch();

    const handleGetItems = () => {
        const groupCustomerId = Cookies.get("groupCustomerId");

        const params = {
            OwnerID: groupCustomerId,
            Channel: 2,
        };
        dispatch(getCatalogueItems(params));
    };

    return handleGetItems;
};

export const useFetchPosDevices = () => {
    const groupCustomerId = Cookies.get("groupCustomerId");
    const dispatch = useDispatch();

    const fetchHardwarePosDevices = async () => {
        await dispatch(getHardwarePosTerminals({ groupCustomerID: groupCustomerId }));
    };

    return fetchHardwarePosDevices;
};
